const isInTheString = (string, toBeSearch) => {
    return string.includes(toBeSearch)
}

const getBrowserName = () => {
    const { userAgent } = navigator
    if (isInTheString(userAgent, 'Chrome')) return 'Chrome'
    if (isInTheString(userAgent, 'Firefox')) return 'FireFox'
    if (isInTheString(userAgent, 'Chromium')) return 'Chromium'
    if (isInTheString(userAgent, 'Safari')) return 'Safari'
    if (isInTheString(userAgent, 'Opera') || isInTheString(userAgent, 'OPR'))
        return 'Safari'
    if (isInTheString(userAgent, 'MSIE')) return 'Internet Explorer o EDGE'
    return 'Unknow'
}

const generateBrowserFingerprint = async () => {
    const data = [
        navigator.userAgent,
        navigator.language,
        screen.colorDepth,
        screen.height,
        screen.width,
        screen.availHeight,
        screen.availWidth,
        navigator.hardwareConcurrency,
        navigator.platform,
        new Date().getTimezoneOffset(),
        Date.now(),
    ].join('')

    const encoder = new TextEncoder()
    const dataBuffer = encoder.encode(data)

    const hashBuffer = await crypto.subtle.digest('SHA-256', dataBuffer)
    const hashArray = Array.from(new Uint8Array(hashBuffer))
    const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join('')

    return hashHex
}

export default {
    name: getBrowserName(),
    make: navigator.vendor,
    model: navigator.appVersion,
    system_name: navigator.platform,
    system_version: navigator.platform,
    generateId: generateBrowserFingerprint,
    app_installation_id: 'none',
    app_version_id: 'none',
}